import React from 'react';

function Forbidden() {
  return <h1>Forbidden</h1>;
}

export default Forbidden;
